import { PermissionsApiClient } from "./PermissionsApiClient";

export const fetchPermissions = async ({
  signal,
}: {
  signal: AbortSignal | undefined;
}) => {
  const { data } = await PermissionsApiClient.instance.get(
    "/permissions/v1/me",
    {
      signal,
    }
  );
  return data;
};
